import { render } from "./AlertControl.vue?vue&type=template&id=3df519da"
import script from "./AlertControl.vue?vue&type=script&lang=js"
export * from "./AlertControl.vue?vue&type=script&lang=js"

import "./AlertControl.vue?vue&type=style&index=0&id=3df519da&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__